import { useEffect, useState } from "react";
import { ArrowRight } from "lucide-react";
import { api } from "@/lib/api";

export const Pricelist = ({ onBook }) => {
  const [categories, setCategories] = useState([]);
  const [active, setActive] = useState(null);

  useEffect(() => {
    api.get("/services").then(({ data }) => {
      setCategories(data);
      if (data[0]) setActive(data[0].id);
    }).catch(() => {});
  }, []);

  const current = categories.find((c) => c.id === active);

  return (
    <section id="cjenik" className="section-pad bg-emerald-deep relative" data-testid="pricelist-section">
      <div className="max-w-7xl mx-auto">
        <div className="grid md:grid-cols-12 gap-12 items-end mb-14">
          <div className="md:col-span-7">
            <span className="font-sans tracking-luxury text-[0.65rem] uppercase text-gold/80">— Cjenik</span>
            <h2 className="mt-6 font-serif font-light text-4xl md:text-5xl lg:text-6xl text-[#F5EFE3] leading-[1.1]" data-testid="pricelist-title">
              Sve naše <em className="text-gold not-italic">usluge</em>.
            </h2>
          </div>
          <div className="md:col-span-5">
            <p className="font-serif text-base md:text-lg text-[#F5EFE3]/80 leading-relaxed">
              Sve cijene su izražene u eurima (€) i okvirne — konačnu cijenu definiramo nakon
              kratke analize vaše kose i dogovora oko željenog rezultata.
            </p>
          </div>
        </div>

        {/* Category tabs */}
        <div className="flex flex-wrap gap-2 border-b border-gold/15 pb-px mb-10">
          {categories.map((c) => (
            <button
              key={c.id}
              onClick={() => setActive(c.id)}
              data-testid={`cat-tab-${c.id}`}
              className={`px-5 py-3 font-sans tracking-wide-2 text-[0.65rem] uppercase border-b-2 transition ${
                active === c.id
                  ? "border-gold text-gold"
                  : "border-transparent text-[#F5EFE3]/65 hover:text-gold"
              }`}
            >
              {c.name}
            </button>
          ))}
        </div>

        {/* Items list */}
        {current && (
          <div className="grid lg:grid-cols-12 gap-12 lg:gap-16" data-testid={`cat-panel-${current.id}`}>
            <aside className="lg:col-span-4">
              <p className="font-script text-4xl md:text-5xl text-gold leading-tight">{current.name}</p>
              <div className="mt-6 sep-gold" />
              <p className="mt-6 font-serif text-base text-[#F5EFE3]/80 leading-relaxed">{current.tagline}</p>
              <button
                onClick={() => onBook?.(current.items[0]?.id)}
                data-testid={`cat-book-${current.id}`}
                className="btn-luxury mt-10"
              >
                Rezerviraj <ArrowRight className="w-4 h-4" />
              </button>
            </aside>

            <ul className="lg:col-span-8 divide-y divide-gold/10">
              {current.items.map((item, idx) => (
                <li
                  key={item.id}
                  data-testid={`price-row-${item.id}`}
                  className="py-5 flex items-baseline gap-4 group cursor-pointer"
                  onClick={() => onBook?.(item.id)}
                >
                  <span className="font-serif text-gold/40 tabular-nums w-8 shrink-0">{String(idx + 1).padStart(2, "0")}</span>
                  <span className="font-serif text-lg md:text-xl text-[#F5EFE3] group-hover:text-gold transition">
                    {item.name}
                    {item.unit && <span className="ml-2 font-sans text-[0.65rem] tracking-luxury uppercase text-[#B0C4B1]/70">{item.unit}</span>}
                  </span>
                  <span className="flex-1 mx-2 border-b border-dotted border-gold/20 translate-y-[-4px]" />
                  <span className="font-serif text-xl md:text-2xl text-gold tabular-nums">{item.price}<span className="text-sm align-baseline ml-1 text-gold/70">€</span></span>
                </li>
              ))}
            </ul>
          </div>
        )}
      </div>
    </section>
  );
};
